import Link from '../../views/Link2approverequest';
import { connect } from 'react-redux';
import { actions } from '../../../state/assessment';
import { push } from 'connected-react-router';

const mapStateToProps = (state, ownProps) => ({
  intel: ownProps.match.params.intel,
  locale: ownProps.match.params.locale,
  status: state.shift.status,
  membername: state.shift.assessment.membername,
  memberusername: state.shift.assessment.memberusername,
  memberemail: state.shift.assessment.memberemail,
  membertelephone: state.shift.assessment.membertelephone,
  memberrole: state.shift.assessment.memberrole,
  memberstatus: state.shift.assessment.memberstatus
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;

  return {
    saveMemberName: username => {
      console.log('I am approbe:');
      dispatch(actions.saveMemberName(username));
      //   .then(() =>
      //   dispatch(push(`/${locale}/approve`))
      // );
    },

    gotopage: () => {
      console.log('approbe:');
      dispatch(push(`/${locale}/link2approverequestpage`));
    }
  };
};

const Link2approverequest = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default Link2approverequest;



// WEBPACK FOOTER //
// ./src/components/container/Link2approverequest/index.js